import React, { FC } from 'react'
import { numberWithCommas, simpleSort } from '../../../_utils/utils'
import { Popover } from 'antd'
import { OrgSegmentModel } from '../../../models/segments/org-segment.model'

type OrgSegmentRowReachBreakdownProps = {
    segment: OrgSegmentModel
}

export const OrgSegmentRowReachBreakdown: FC<OrgSegmentRowReachBreakdownProps> = ({ segment }) => {
    const isMultiDomain = segment.getIsMultiDomain() ?? false
    const title = isMultiDomain ? 'Domains / Audience Size' : 'Domain'

    const childSegments = segment.getSegments()
    childSegments.sort((a, b) => simpleSort(a.domain_display_name, b.domain_display_name))

    return (
        <Popover
            key="domains-badge"
            overlayClassName="segment-list-domains-popover"
            title={title}
            content={childSegments.map(({ id, domain_display_name, estimated_reach }) => (
                <div key={id} className="segment-list-domains-item">
                    <span className="domains-item-label">{domain_display_name}</span>

                    {isMultiDomain && (
                        <span className="domains-item-reach">
                            {!estimated_reach ? '--' : numberWithCommas(estimated_reach)}
                        </span>
                    )}
                </div>
            ))}
        >
            <span className="segment-list-domains-badge">
                {isMultiDomain ? <span>{segment.getDomainIds().length} Domains</span> : <span>1 Domain</span>}
            </span>
        </Popover>
    )
}
